import Symbol$1 from "./component-library274.mjs";
import getRawTag from "./component-library275.mjs";
import objectToString from "./component-library276.mjs";
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
export {
  baseGetTag as default
};
